import React from "react";
import LocalizedWeatherGuidePage from "@/components/weather/LocalizedWeatherGuidePage";

export default function WeatherScoreGuide() {
  return <LocalizedWeatherGuidePage guideKey="score" />;
}